import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { TextField, Button, Typography, Divider, Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Card, CardContent, Grid, Chip } from "@mui/material";
import { Search, Tune } from "@mui/icons-material";
import SideMenu from '../components/SideMenu';
import TopMenu from '../components/TopMenu';
import AddProductPickingModal from '../components/AddProductPickingModal';
import RemoveProductPickingModal from '../components/RemoveProductPickingModal';
import ConfirmFinishOrderPickingModal from '../components/ConfirmFinishOrderPickingModal';
import { pink, blue, teal, yellow, orange, indigo } from '@mui/material/colors';

const dataGraph = [
  { name: "Group A", value: 400, fill: "#0088FE" },
  { name: "Group B", value: 300, fill: "#00C49F" },
  { name: "Group C", value: 300, fill: "#FFBB28" },
  { name: "Group D", value: 200, fill: "#FF8042" }
];

function Picking() {
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [removeModalOpen, setRemoveModalOpen] = useState(false);
  const [finishModalOpen, setFinishModalOpen] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  const handleConfirm = (data) => {
    setAddModalOpen(false);
  };

  const handleConfirmRemoveProduct = (data) => {
    setRemoveModalOpen(false);
  };

  const handleConfirmFinishOrder = (data) => {
    setFinishModalOpen(false);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Top menu */}
      <TopMenu />
      {/* Side menu */}
      <SideMenu />

      {/* Main container */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: 'background.default',
          p: 3,
          marginTop: '64px',
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Box display="flex" gap={2} alignItems="center">
            <Button variant="contained" startIcon={<Search />} sx={{ mt: 2, mb: 2, backgroundColor: indigo[500], color: '#fff' }} onClick={() => navigate(`/warehouse/${id}/sales-order-list`)}>
              Sale Order
            </Button>
            <Button variant="outlined" startIcon={<Tune />} color='primary' sx={{ mt: 2, mb: 2 }}>
              Purchase Order mode
            </Button>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }} style={{marginTop: 40}}>
          <Box sx={{ width: '30%' }}>
            <Paper elevation={3}>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid size="auto">
                    <Typography variant='h6'> Order: PM00000</Typography>
                  </Grid>
                  <Grid size="auto">
                    <Chip label="Not started" color="primary" />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography><strong>Order by:</strong> Test Order by</Typography>
                    <Typography><strong>Customer:</strong> Test Customer</Typography>
                    <Typography><strong>Comments:</strong> Test Comment</Typography>
                    <Typography><strong>Packaging:</strong> Test type of packaging</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ justifyContent: "center", alignItems: "center", pt: 3}}>
                  <Button variant='contained' color='success' size='medium'  onClick={() => setFinishModalOpen(true)}>Finish and print</Button>
                </Grid>
              </CardContent>
            </Paper>
          </Box>

          <Box sx={{ width: '70%' }}>
            {/* Start 70% */}
            <Box>
              <Typography variant="h6" color="primary" fontWeight={600}>Picking List Sales Order</Typography>
              
              <Divider sx={{ mb: 2 }} />

              <TableContainer component={Paper} sx={{ mb: 2 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Item Code</TableCell>
                      <TableCell>Description</TableCell>
                      <TableCell>Quantity Ordered</TableCell>
                      <TableCell>Weight</TableCell>
                      <TableCell>Total Weight</TableCell>
                      <TableCell>Comments</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>FARMCA001</TableCell>
                      <TableCell>Pulmo Grip Jarabe</TableCell>
                      <TableCell>2</TableCell>
                      <TableCell>10.5</TableCell>
                      <TableCell>21</TableCell>
                      <TableCell></TableCell>
                      <TableCell><Button variant='contained' color='primary' size='small' onClick={() => setAddModalOpen(true)}>Add</Button></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            <br /> <br />

            <Typography variant="h6" color={teal[500]} fontWeight={600}>Picked Up List</Typography>
        
            <Divider sx={{ mb: 2 }} />
            
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>LineSeqNo</TableCell>
                    <TableCell>Item Code</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Quantity Ordered</TableCell>
                    <TableCell>Quantity Shipped</TableCell>
                    <TableCell>Weight</TableCell>
                    <TableCell>Total Weight</TableCell>
                    <TableCell>Comments</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    {/* <TableCell colSpan={8} align="center">No data available</TableCell> */}
                    <TableCell>1</TableCell>
                    <TableCell>FARMCA001</TableCell>
                    <TableCell>Pulmo Grip Jarabe</TableCell>
                    <TableCell>2</TableCell>
                    <TableCell>2</TableCell>
                    <TableCell>10.5</TableCell>
                    <TableCell>21</TableCell>
                    <TableCell></TableCell>
                    <TableCell><Button variant='contained' color='error' size='small' onClick={() => setRemoveModalOpen(true)}>Remove</Button></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            {/* End 70% */}
          </Box>
        </Box>

      </Box>
      {/* <Box>
        <Box display="flex" justifyContent="space-between" mt={3}>
          <Button variant="contained" color="success">Finish Order</Button>
          <Button variant="contained" color="primary">Print Order</Button>
        </Box>
      </Box> */}

      <AddProductPickingModal
        open={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        onConfirm={handleConfirm}
      />
      <RemoveProductPickingModal
        open={removeModalOpen}
        onClose={() => setRemoveModalOpen(false)}
        onConfirm={handleConfirmRemoveProduct}
      />
      <ConfirmFinishOrderPickingModal
        open={finishModalOpen}
        onClose={() => setFinishModalOpen(false)}
        onConfirm={handleConfirmFinishOrder}
      />

      
    </Box>
  );
}

export default Picking;
